import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { GlobalContext } from '../../Context/GlobalContext';
import { Snackbar } from '@mui/material';

/**
 * A reusable alert bar component that displays temporary notifications to the user.
 * The alert bar appears at the bottom of the screen and automatically hides after a set duration.
 * It supports different severity levels (e.g., success, error, warning, info) and can be closed manually.
 * 
 * @component
 * @returns {JSX.Element} The rendered alert bar component.
 * @example
 * <AlertBar />
 */
const AlertBar = () => {
  const { alertBarOpen, setAlertBarOpen, alertBarMessage, alertBarSeverity } = React.useContext(GlobalContext);
  
  /**
   * Handles closing the alert bar by setting the `alertBarOpen` state to `false`.
   */
  const handleClose = () => {
    setAlertBarOpen(false)
  };

  return (
    <Snackbar
      open={alertBarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Box sx={{ width: '100%', position: "fixed",  bottom: 0, left: 0, zIndex: 1200}}>
        <Collapse in={alertBarOpen}>
          <Alert
          severity={alertBarSeverity}
          onClose={handleClose}
          >
            {alertBarMessage}
          </Alert>
        </Collapse>
      </Box>
    </Snackbar>    
  );
}

export default AlertBar;
